import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from './../MaterialSelector';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { ownerscabinImageOptions } from './views/ownerscabin'

class XP44OwnersCabin extends Component {
    constructor(props) {
        super(props);
        this.handleFabricChange = this.handleFabricChange.bind(this);
        this.handleOwnersCabinLayoutChange = this.handleOwnersCabinLayoutChange.bind(this);
        this.handleOwnerBerthChange = this.handleOwnerBerthChange.bind(this);
    }

    handleFabricChange(newValue) {
        let configuration = this.props.configuration;
        configuration.FabricCabins = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleOwnersCabinLayoutChange(newValue) {
        let configuration = this.props.configuration;
        configuration.OwnersCabinLayout = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleOwnerBerthChange(newValue) {
        let configuration = this.props.configuration;
        configuration.OwnerBerth = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = ownerscabinImageOptions;

        let image = <ConfiguratorImage boat="XP44" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Owner’s cabin' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='Standard in the owner’s cabin is upper cupboards.' /></p>

                    <h2><Trans defaults='Options' /></h2>

                    <RadioGroup label="Layout:" options={this.props.ownersCabinLayoutOptions} value={this.props.configuration.OwnersCabinLayout} onChange={this.handleOwnersCabinLayoutChange} />

                    <h2><Trans defaults='Fabrics' /></h2>
                    <MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.FabricCabins.label} value={this.props.configuration.FabricCabins} onChange={this.handleFabricChange} />

                   
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP44OwnersCabin);


// WEBPACK FOOTER //
// ./src/XP44/XP44OwnersCabin.js